const NotFound = () => {
    return (
        <div className="not-found-wrapper">
            <h1>Página não encontrada</h1>
        </div>
    )
}

export default NotFound;
